import { render } from "./ContactPickerModal.vue?vue&type=template&id=0352fa7a&scoped=true"
import script from "./ContactPickerModal.vue?vue&type=script&lang=js"
export * from "./ContactPickerModal.vue?vue&type=script&lang=js"

import "./ContactPickerModal.vue?vue&type=style&index=0&id=0352fa7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0352fa7a"

export default script